import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FileTextOutlinedSvg from "@ant-design/icons-svg/es/asn/FileTextOutlined";
import AntdIcon from "../components/AntdIcon";
var FileTextOutlined = function FileTextOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileTextOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FileTextOutlined.displayName = 'FileTextOutlined';
}
export default /*#__PURE__*/React.forwardRef(FileTextOutlined);